import { useEffect, useRef, useState } from "react";
import { KendoEditor } from "../../Kendo/kendo_editor";
import {
  Button,
  ErrorMsg,
  GetFormData,
  Loader,
  ValidateForm,
  checkAccess,
  sessionUser,
} from "../../Util/common";
import { post } from "../../Util/axios_helper";
import { useDispatch, useSelector } from "react-redux";
import { getInquiryThankyou, onRefresh } from "./app_config_slice";
import { KendoDropdown } from "../../Kendo/kendo_dropdown";
import { KendoLoader } from "../../Kendo/kendo_loader";
import { getTemplateDataFields } from "../Email/template_slice";

export const InquiryConfigComp = ({ selTab }) => {
  const dispatch = useDispatch();
  const { inquiryThankyou, inquiryThankyouLoaded, refresh } = useSelector(
    (state) => state.appConfig
  );
  const { templateFields, templateFieldsLoaded } = useSelector(
    (state) => state.emailTemplate
  );
  const [error, setError] = useState({});
  const [DescFlag, setDescFlag] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [Desc, setDesc] = useState("");

  const [type, setType] = useState("Recommendation_Thankyou_Single");
  const options = [
    {
      id: "Recommendation_Thankyou_Single",
      text: "Recommendation - Thankyou (Single Function)",
    },
    {
      id: "Recommendation_Thankyou_Multi",
      text: "Recommendation - Thankyou (Double Function)",
    },
    { id: "Recommendation_OtherDates", text: "Recommendation - Other Dates" },
    { id: "Recommendation_Footer", text: "Recommendation - Footer" },
    { id: "SMS_Thankyou", text: "SMS - Thankyou" },
    { id: "SMS_Reminder", text: "SMS - Reminder" },
  ];

  const dataFieldsForSMS = [
    { TemplateDataFieldId: 1, DataFieldName: "FirstName" },
    { TemplateDataFieldId: 2, DataFieldName: "LastName" },
  ];
  const [wordCount, setWordCount] = useState(0);
  const parser = new DOMParser();
  const textareaRef = useRef(null);

  useEffect(() => {
    if (selTab == 5) {
      dispatch(getTemplateDataFields("EMAIL"));
      dispatch(getInquiryThankyou(type));
    }
  }, [selTab]);

  useEffect(() => {
    getWordCount(inquiryThankyou);
    setDesc(inquiryThankyou);
  }, [inquiryThankyou, refresh]);

  const getWordCount = (htmlContent) => {
    let count = 0;
    if (htmlContent) {
      const doc = parser.parseFromString(htmlContent, "text/html");
      if (doc && doc.body) {
        const textNodes = doc.body.textContent;
        count = textNodes.length;
        setWordCount(count);
      }
    }
    return count;
  };

  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const strippedValue = Desc.replace(/<\/?[^>]+(>|$)/g, "")
      .replace(/&nbsp;/g, " ")
      .trim();
    const sanitizedValue = /^[\s\n]*$/.test(strippedValue);

    setDescFlag(sanitizedValue);

    var err = ValidateForm(e);
    if (err) {
      setError(err);
    } else if (!sanitizedValue) {
      setLoading(true);
      let data = GetFormData(e);
      data.SettingValue = Desc;
      data.SavedBy = sessionUser();
      await post("Configuration/SaveSettings", data);
      dispatch(getInquiryThankyou(type));
      setLoading(false);
    }
  };

  const onCancel = (e) => {
    dispatch(onRefresh());
    if (textareaRef.current) {
      textareaRef.current.value = inquiryThankyou;
    }
    setDescFlag(false);
    setError({});
  };

  const onDrag = (e) => {
    e.dataTransfer.setData("text/plain", `{${e.currentTarget.innerText}}`);
  };

  return (
    <form id="form-inquiry-thankyou" onSubmit={onSubmit}>
      <div className="row no-gutters">
        <div className="col-md-9">
          <div className="form-group mb-3">
            <label className="form-label">Type</label>
            <KendoDropdown
              name={"SettingName"}
              data={options}
              value={type}
              dataTextField={"text"}
              dataValueField={"id"}
              onChange={(e) => {
                setType(e);
                setWordCount(0);
                setError({});
                dispatch(getInquiryThankyou(e));
                dispatch(
                  getTemplateDataFields(
                    e == "Recommendation_Thankyou_Multi"
                      ? "EMAIL_MULTI"
                      : "EMAIL"
                  )
                );
              }}
            />
          </div>
        </div>
        <div className="col-md-3">
          <div className="row d-flex justify-content-end">
            {(checkAccess("APPCONFIGCREATE") || checkAccess("APPCONFIGEDIT")) &&
              (Loading ? (
                <KendoLoader className="d-flex justify-content-end align-items-center" />
              ) : (
                <div className="col-md d-flex justify-content-end align-items-center mt-2">
                  <Button
                    name={"Cancel"}
                    isCancelButton={true}
                    onClick={onCancel}
                  />
                  <Button name={"Save"} />
                </div>
              ))}
          </div>
        </div>
      </div>

      {inquiryThankyouLoaded ? (
        <>
          <div className="row" style={{ fontSize: "12px" }}>
            <div className="col-md-8">
              <span>
                <i>
                  <span style={{ backgroundColor: "yellow" }}>Note:</span>{" "}
                  Please ensure that the content remains under{" "}
                  {type == "SMS_Thankyou" || type == "SMS_Reminder" ? 130 : 300}{" "}
                  characters
                </i>
              </span>
            </div>
            <div className="col-md-4">
              <span style={{ color: "grey" }}>
                <i>
                  {wordCount}/{" "}
                  {type == "SMS_Thankyou" || type == "SMS_Reminder" ? 130 : 300}
                </i>
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col-md-9">
              {type == "SMS_Thankyou" || type == "SMS_Reminder" ? (
                <textarea
                  className="form-control"
                  name="SettingValue"
                  ref={textareaRef}
                  rows={4}
                  onInput={(e) => {
                    const wc = e.target.value.length;
                    if (wc > 130) {
                      let words = e.target.value;
                      e.target.value = words.slice(0, 130);
                      setWordCount(130);
                      setError({ WordLimit: true });
                    } else {
                      setWordCount(wc);
                      if (error.WordLimit) {
                        setError({});
                      }
                    }
                  }}
                  onChange={(e) => {
                    onValidation("SettingValue", e.target.value);
                  }}
                  defaultValue={inquiryThankyou}
                ></textarea>
              ) : (
                <KendoEditor
                  name="SettingValue"
                  height={"292px"}
                  value={inquiryThankyou}
                  // required={true}
                  onValidate={onValidation}
                  onChange={(e) => {
                    const strippedValue = e
                      .replace(/<\/?[^>]+(>|$)/g, "")
                      .replace(/&nbsp;/g, " ")
                      .trim();
                    const sanitizedValue = /^[\s\n]*$/.test(strippedValue);

                    setDescFlag(sanitizedValue);
                    setDesc(e);
                    getWordCount(e);
                  }}
                  refreshWhen={refresh}
                />
              )}

              {/* {error.SettingValue && <ErrorMsg text={"*required"} />} */}
              {DescFlag && <ErrorMsg text={"Required"} />}
              {error.WordLimit && (
                <ErrorMsg
                  text={
                    "Maximum character limit exceeded. Please enter up to 130 characters"
                  }
                />
              )}
              {error.RecWordLimit && (
                <ErrorMsg
                  text={
                    "Maximum character limit exceeded. Please enter up to 300 characters"
                  }
                />
              )}
            </div>
            <div className="col-md-3">
              <div
                style={{
                  border: "1px solid rgba(0,0,0,.08)",
                  height:
                    type == "SMS_Thankyou" || type == "SMS_Reminder"
                      ? "104px"
                      : "293px",
                  overflowY: "auto",
                }}
              >
                {type == "SMS_Thankyou" || type == "SMS_Reminder"
                  ? dataFieldsForSMS.map((e) => {
                      return (
                        <span
                          key={e.TemplateDataFieldId}
                          className="k-button k-button-solid-base k-button-solid k-button-md k-rounded-md hide-on-narrow k-editor-datafields"
                          draggable="true"
                          onDragStart={onDrag}
                        >
                          {e.DataFieldName}
                        </span>
                      );
                    })
                  : templateFields &&
                    templateFields.map((e) => {
                      return (
                        <span
                          key={e.TemplateDataFieldId}
                          className="k-button k-button-solid-base k-button-solid k-button-md k-rounded-md hide-on-narrow k-editor-datafields"
                          draggable="true"
                          onDragStart={onDrag}
                        >
                          {e.DataFieldName}
                        </span>
                      );
                    })}
              </div>
            </div>
          </div>
        </>
      ) : (
        <KendoLoader />
      )}
    </form>
  );
};
